import { TutorialSectionIcon } from "@/components/common/page-section/icon/tutorial-section-icon";
import {
  BookHeartIcon,
  BookmarkIcon,
  CalculatorIcon,
  CalendarIcon,
  Clock4Icon,
  InfoIcon,
  NewspaperIcon,
  SaveIcon,
} from "lucide-react";

export const pageSectionIcons = {
  tutorial: <TutorialSectionIcon />,
  time: <Clock4Icon size={16} />,
  info: <InfoIcon size={16} />,
  save: <SaveIcon size={16} />,
  calendar: <CalendarIcon size={16} />,
  newspaper: <NewspaperIcon size={16} />,
  ebook: <BookHeartIcon size={16} />,
  calculator: <CalculatorIcon size={16} />,
  bookmark: <BookmarkIcon size={16} />,
};
